// NIC portals (eProcure, eTenders, Jharkhand) publish a Tender ID such as
// "2026_BHEL_65076_1", and the scrapers store it inside the reference next to
// the portal's Ref.No. ("/L8A1Z44869/2026_BHEL_65076_1",
// "[HVF/CAM/AFV/310826][2026_AVNL_289382_1]"). GeM and IREPS store the bid /
// tender number itself as the reference.
const NIC_TENDER_ID = /\d{4}_[A-Za-z0-9&.-]+_\d+_\d+/;

// The Tender ID people search with, or the whole reference when none is embedded.
export function tenderIdOf(reference) {
  if (!reference) return "";
  const match = String(reference).match(NIC_TENDER_ID);
  return match ? match[0] : String(reference).trim();
}

// The portal's Ref.No. with the Tender ID and its bracket/slash wrapping
// removed, or "" when the reference is nothing but the Tender ID.
export function refNoOf(reference) {
  if (!reference) return "";
  const id = tenderIdOf(reference);
  const rest = String(reference)
    .replace(id, "")
    .replace(/\[\s*\]/g, "")
    .replace(/^[\s/[\]]+|[\s/[\]]+$/g, "")
    .trim();
  return rest === id ? "" : rest;
}
